import React, { useEffect, useState } from 'react';
import { getTeam } from '../../api/api';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Team.scss';

const placeholderImg = require('../../assets/about/team/1.png'); // Use your preferred placeholder

const Team = () => {
    const [teams, setTeams] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const data = await getTeam();
            setTeams(data);
        }
        fetchData();
    }, []);

    return (
      <section
        className="team-section pt-100"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <SectionTitle
                subTitle="Meet our Team"
                title="Get to know the dentalist dental Team"
              />
            </div>

            <div className="col-lg-5">
              <p className="pt-5">
                Our expert dentists and caring staff are dedicated to providing
                top-quality dental care in a friendly and comfortable
                environment. 
              </p>
            </div>
          </div>

          <div className="row">
            {teams.map((team) => (
              <div className="col-lg-3 col-sm-6" key={team.id}>
                <div className="team-card">
                  <div className="team-img">
                    <img 
                      src={team.photo_url || placeholderImg} 
                      alt={team.name} 
                      className="team-photo"
                      style={{
                        width: '400px',
                        height: '400px',
                        objectFit: 'cover',
                        // borderRadius: '50%',
                        display: 'block',
                        margin: '0 auto'
                      }}
                    />
                  </div>
                  <h3>{team.name}</h3>
                  <p><strong>{team.role}</strong></p>
                  <p>{team.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
};

export default Team;